const Health = (props: any) => {
  const timestamp = Date.now().toString()
  console.log(`Health check successful at ${timestamp} ---------------`)
  return (
    <></>
  )
}

export default Health;